import "./src/fonts/fonts.css"
import "./src/styles/global.css"
import gsap from "gsap"
import ScrollTrigger from "gsap/ScrollTrigger"
import { ScrollToPlugin } from "gsap/ScrollToPlugin"

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin)
